import axios from 'axios';
import { getBaseUrl } from '@/config'

let base = getBaseUrl();

export const requestLogin = params => { return axios.get(`${base}api/app/login`, {params:params} ).then(res => res.data); };

export const getshengshi = params => { return axios.get(`${base}api/app/getshengshi`, {params:params} ).then(res => res.data); };

export const getqiyelist = params => { return axios.get(`${base}api/app/getqiyelist`, {params:params} ).then(res => res.data); };

export const editqiye = params => { return axios.post(`${base}api/app/editqiye`,params).then(res =>res.data);} 

export const delqiye = params => { return axios.get(`${base}api/app/delqiye`, {params:params} ).then(res => res.data); };

//api/app/getqiyetoselect

export const getqiyetoselect = params => { return axios.get(`${base}api/app/getqiyetoselect`, {params:params} ).then(res => res.data); };

//api/app/getdevicelist
 
export const getdevicelist = params => { return axios.get(`${base}api/app/getdevicelist`, {params:params} ).then(res => res.data); };

//editdevice
export const editdevice = params => { return axios.post(`${base}api/app/editdevice`,params).then(res =>res.data);} 

//jiebang
export const jiebang = params => { return axios.post(`${base}api/app/jiebang`,params).then(res =>res.data);} 

//getrizhilist
export const getrizhilist = params => { return axios.get(`${base}api/app/getrizhilist`,{params:params} ).then(res =>res.data);} 

//getallrole
export const getallrole = params => { return axios.get(`${base}api/app/set/role/list`,{params:params} ).then(res =>res.data);} 

//editrole 
export const editrole = params => { return axios.post(`${base}api/app/set/role/edit`,params).then(res =>res.data);} 

//delrole
export const delrole = params => { return axios.get(`${base}api/app/set/role/del`,{params:params} ).then(res =>res.data);} 

//getalluser
export const getalluser = params => { return axios.get(`${base}api/app/set/user/list`,{params:params}).then(res =>res.data);} 

//edituser
export const edituser = params => { return axios.post(`${base}api/app/set/user/edit`,params).then(res =>res.data);} 

//deluser
export const deluser = params => { return axios.get(`${base}api/app/set/user/del`,{params:params}).then(res =>res.data);} 

//chongzhi
export const chongzhimm = params => { return axios.get(`${base}api/app/chongzhi`,{params:params}).then(res =>res.data);} 

//gethomedata
export const gethomedata  = params => { return axios.get(`${base}api/app/gethomedata`,{params:params}).then(res =>res.data);} 

//
export const gethomebyshengfen = params => { return axios.get(`${base}api/app/gethomebyshengfen`,{params:params}).then(res =>res.data);} 

//getqiyeinfo
export const getqiyeinfo = params => { return axios.get(`${base}api/app/getqiyeinfo`,{params:params}).then(res =>res.data);} 

//delshebei
export const delshebei = params => { return axios.get(`${base}api/app/delshebei`,{params:params}).then(res =>res.data);} 

//getallarea
export const getallarea = params => { return axios.get(`${base}api/app/getareadata`,{params:params}).then(res =>res.data);} 

//编辑学校信息
export const editschool = params => { return axios.post(`${base}api/app/school/edit`,params).then(res =>res.data);} 

//获取校区导航左侧界面 app/school/getinfo
export const school_getinfo = params =>{ return axios.get(`${base}api/app/school/getinfo`,{params:params}).then(res =>res.data);} 


//获取校区列表
export const school_list= params =>{ return axios.get(`${base}api/app/school/list`,{params:params}).then(res =>res.data);} 

//删除校区信息
export const school_del = params => { return axios.get(`${base}api/app/school/del`, {params:params} ).then(res => res.data); };

export const homeinfo = params => { return axios.get(`${base}api/app/home`, {params:params} ).then(res => res.data); };

export const getcityschools = params => { return axios.get(`${base}api/app/getschoolinfo`, {params:params} ).then(res => res.data); };


